<template>
    <div class="routerPage collect_wrap">

    </div>
</template>

<script>
import ajaxService from '@/server/api.js'
import moment from 'moment';

export default {
    name: 'login',
    data() {
        return {
            pageId: 0,
        }
    },

    created() {

        
        let iUserID = this.$route.query.uid;
        let iCompanyID = this.$route.query.cid;
        let iUserType = this.$route.query.type;//0:未付费用户 1:试用账户 2:付费用户
        let iTime = this.$route.query.time;
        let sBackUrl = this.$route.query.url || "http://www.youcaiyun.com/";
        let sSign = this.$route.query.sign;
        let sTourl = this.$route.query.tourl || '';
        let sUserRole = this.$route.query.role || ''; // 子账户权限 1:房企拿地监控 2:房企项目 3:全装修 4:招标采购 5:研究报告 6:我的业绩

        let LandDownloads = this.$route.query.landDownloads || 0  // 房企拿地的下载量
        let ProjectDownloads = this.$route.query.projectDownloads || 0  // 项目开工的下载量
        let DecorateDownloads = this.$route.query.decorateDownloads || 0 // 全装修市场的下载量
        let SearchDownloads = this.$route.query.searchDownloads || 0   // 研究报告的下载量
        let ProvinceCityId = this.$route.query.ProvinceCityId || ''

        let sSource = this.$route.query.sSource || 'youcai'

        // 页面跳转类型
        this.pageId = this.$route.query.pageId;
        let data = {
            iUserID: iUserID || 0,
            iUserType: iUserType || 0,
            iCompanyID: iCompanyID || 0,
            iTime: iTime || 0,
            sSign: sSign || '',
            sApiType: 'login',
            sUserRole: sUserRole || '',
            iLandDownloads: LandDownloads,
            iProjectDownloads: ProjectDownloads,
            iDecorateDownloads: DecorateDownloads,
            iSearchDownloads: SearchDownloads,
            ProvinceCityId: ProvinceCityId,
            sSource: sSource
        }
        let _this = this
        _this.sTourl = sTourl

        // 登录验证 获取token
        ajaxService.getLoginToken({ data }).then(res => {

            console.log('data======>>>', res)


            if (res.ErrorCode == 0) {

                localStorage.setItem('sZfyxToken', res.Data['token']);
                localStorage.setItem('sZfyxRole', res.Data['role']);
                localStorage.setItem('sZfyxType', res.Data['type']);
                localStorage.setItem('sZfyxTime', moment())
                localStorage.setItem('sZfyxUid', iUserID)
                if (res.Data['type'] == 0) {
                    //未付费用户默认跳转☞招标列表页
                    this.$router.push('/page/tender')
                } else {

                    // 指定来源跳转
                    if (_this.sTourl) {
                        window.location.href = _this.sTourl
                    }

                    console.log('pageId', _this.pageId)

                    let url = ''

                    // 1土地 , 2项目, 3市场,  4报告, 5招标  6拿地列表、7项目开工列表、8全装修列表、9研究报告
                    switch (_this.pageId) {
                        case "1":
                            url = '/fullscreen/land';
                            break;
                        case "2":
                            url = '/fullscreen/project';
                            break;
                        case '3':
                            url = '/fullscreen/market';
                            break;
                        case '4':
                            url = '/fullscreen/report';
                            break;
                        case '5':
                            url = '/page/tender';
                            break;
                        case '6':
                            url = '/page/land';
                            break;
                        case '7':
                            url = '/page/project';
                            break;
                        case '8':
                            url = '/page/market';
                            break;
                        case '9':
                            url = '/page/report';
                            break;
                        default:
                            url = '/'
                    }
                    console.log('url00000000', url)
                    this.$router.push(url)
                }

            } else {
                setTimeout(() => {
                    // window.location.href=sBackUrl
                }, 2000)
            }
        }).catch(function (error) {
            console.log(error)
        });
    },
}
</script>
